exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n.tinymce-container {\n  position: relative;\n  line-height: normal;\n}\n.tinymce-container > > > .mce-fullscreen {\n  z-index: 10000;\n}\n.tinymce-textarea {\n  visibility: hidden;\n  z-index: -1;\n}\n.tox-tinymce-aux {\n  z-index: 10001 !important;\n}\n", ""]);

// exports
exports.locals = {
	"xrColorPrimary": "#2362FB"
};